import { Routes, Route } from "react-router-dom";
import StockForm from "../components/StockForm/Entry/Form";
import EditStockForm from "../components/StockForm/Edit/EditStockForm";
import Partnership from "../components/Partnership/Partnership";
import PrivateRoute from "./PrivateRoute";
import Home from "../components/Home/Home";
import { handleLogin } from "../auth/authHandlers";
import PublicPortfolio from "../components/Home/PublicPortfolio";
import CommunityPage from "../components/Community/Community";

function AppRoutes({ showToast, userId, user }) {

    const username = user?.email
        ? user.email.split("@")[0]
        : null;

    return (
        <Routes>

            {/* HOME */}
            <Route
                path="/"
                element={
                    <Home
                        onLogin={() => handleLogin({ showToast })}
                    />
                }
            />
            <Route path="/community" element={<CommunityPage />} />
            {/* PUBLIC COMMUNITY PROFILE */}
            <Route
                path="/community/:username"
                element={<PublicPortfolio showToast={showToast} />}
            />

            {/* PRIVATE ROOT */}
            <Route
                path="/:username"
                element={
                    <PrivateRoute showToast={showToast}>
                        <PublicPortfolio />
                    </PrivateRoute>
                }
            />

            {/* PRIVATE ENTRY */}
            <Route
                path="/:username/entry"
                element={
                    <PrivateRoute showToast={showToast}>
                        <StockForm userId={userId} username={username} showToast={showToast} />
                    </PrivateRoute>
                }
            />

            {/* PRIVATE EDIT */}
            <Route
                path="/:username/edit"
                element={
                    <PrivateRoute showToast={showToast}>
                        <EditStockForm userId={userId} showToast={showToast} />
                    </PrivateRoute>
                }
            />

            {/* PRIVATE PARTNERSHIP */}
            <Route
                path="/:username/partnership"
                element={
                    <PrivateRoute showToast={showToast}>
                        <Partnership userId={userId} showToast={showToast} />
                    </PrivateRoute>
                }
            />

        </Routes>
    );
}

export default AppRoutes;